import { Component, HostListener, OnInit } from '@angular/core';
import { COLORLIST, CONST_AWS_API, API } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommanSubscribeService } from './../../../../../core/services/comman-subscribe.service';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { runInThisContext } from 'vm';
// import { ThrowStmt } from '@angular/compiler';
import { DomSanitizer } from '@angular/platform-browser';
import { API as AWS_API } from 'aws-amplify';
import { SvgService } from 'src/app/core/services/svg.service';
import { AppService } from 'src/app/core/services/app.service';
declare let $: any;
declare var WTSDK: any;

@Component({
  selector: 'app-network-room',
  templateUrl: './network-room.component.html',
  styleUrls: ['./network-room.component.scss'],
  host: {
    'window:beforeunload': 'beforeUnloadEvent',
    'window:pagehide': 'pageHideEvent',
    'window:onunload': 'onunloadEvent'
  }
})
export class NetworkRoomComponent implements OnInit {
  userInfo: any;
  userInfoSubscription: Subscription;
  roomId: any;
  roomInfo: any;
  isStarted = true;
  AuthToken: any;
  qualityConstants = {
    bad: 'bad',
    good: 'good',
    excellent: 'excellent',
  };

  MediaTypes = {
    AUDIO: 'AUDIO',
    VIDEO: 'VIDEO'
  };

  MediaStates = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED'
  };
  token: any;
  userName: any;
  waiting: number;
  preview: number;
  live: number;
  uname: any;
  mainRoom: any = {};
  subRoomData: any = [];
  subRoomName: string = "";
  networkInterval: any;
  session_id: any;
  isExpand: boolean = false;
  isDataCalled: boolean = false;
  isDisconnected: boolean = false;
  videoRoomsJson: any;
  currentVideoRoom: any;
  isAutoAssign: boolean = true;
  orgID: any;
  isRoomStarted: boolean = false;
  countUserColor = 0;
  userColor: any = {};
  cIndex: number;
  isRoomCreating: boolean = false;
  hostID: any;
  isDisconnectRoom: boolean = false;
  showVideoInterval: ReturnType<typeof setInterval> | undefined; //NodeJS.Timer;;
  message: any;
  isClosing: number = 0;
  sessionList: any = [];
  adInfo: any;
  ip: any = null;
  streamAdsData: any;
  sponsorData: any;
  preloadAdsdata: any[];
  adVideo: any;
  allAds: any;
  eventHomeAdsTop: any[];
  eventHomeAdsRight: any[];
  streamAdsDataRight: any[];
  streamAdsDataTop: any[];
  streamAds: any;
  streamInfoData: any;
  streamInfo: any = {};
  assets_url: any;
  audio_Icon: string = 'mic-hover';
  video_Icon: string = 'video-hover';
  constructor(
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    public toastr: ToastrService,
    private commanSubscribeService: CommanSubscribeService,
    private _location: Location,
    private router: Router,
    private sanitizer: DomSanitizer,
    private svgService: SvgService,
    private appService: AppService,
  ) {
    this.roomId = this.route.snapshot.params.room_id;
    this.session_id = this.route.snapshot.params.session_id;
    this.videoRoom = this.route.snapshot.params.room_token;
  }
  @HostListener('window:beforeunload', ['$event']) beforeUnloadEvent(eventObject) {
    alert("hello1");
    this.leaveRoom();
  }
  @HostListener('window:pagehide') pageHideEvent() {
    alert("hello2");
    this.leaveRoom();
  }
  @HostListener('window:onunload') onunloadEvent() {
    alert("hello3");
    this.leaveRoom();
  }
  ngOnInit() {
    this.assets_url = environment.assets_url;
    this.commanSubscribeService.sendScreenStatus(false);
    this.loginSubmit();
    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    let slugData = this.commanSubscribeService.slugInfo;
    console.log(slugData, 'hi');
    this.eventDetails(slugData);
    // slugData = this.commanSubscribeService.getSlugData().subscribe(response => {
    //   console.log(response,'response for test'); 
    //   this.adInfo = response;
    //   this.eventDetails(this.adInfo);
    //   console.log(slugData,'hddi');
    // });
    // console.log( this.adInfo,' this.adInfo');
    // console.log( this.userInfo,' this.userInfo');
    this.getUserInfo();
    // this.getRoomById();
    this.networkInterval = setInterval(() => {
      this.getRoomById();
    }, 4 * 5000);

  }

  getUserInfo() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }

    let splits = this.route.snapshot.params.ticket_key.split("-");
    let url = CONST_AWS_API.GET_CONTACT_DETAILS + '/' + splits[1];
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        let userInfo = response['data']['Data'];
        userInfo.signedIn = true;
        userInfo.is_profile_completed = true;
        userInfo.access_token = this.userInfo.access_token;
        this.commanSubscribeService.sendUserInfo(userInfo);
        // this.guestConnect();
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

  getRoomById() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = `${CONST_AWS_API.GET_NETWORK_ROOM_BY_ID}/${this.roomId}`;
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.roomInfo = response['data']['Data'] || {};
        if (this.roomInfo) {
          this.mainRoom = {
            id: this.roomInfo.room_id,
            room: this.roomInfo.name,
            participants: []
          }
          this.videoRoomsJson = JSON.parse(this.roomInfo.video_rooms_json) || [];
          console.log("video rooms", this.videoRoomsJson);
          if (!this.isDataCalled) {
            if (this.roomInfo.host_manage_subroom == 0) {
              for (let i = 0; i < this.videoRoomsJson.length; i++) {
                console.log(environment.networking.allowed_limit, 'length', this.videoRoomsJson[i].users.length);
                if (this.videoRoomsJson[i].users.length < environment.networking.allowed_limit) {
                  this.cIndex = i;
                  break;
                }
              }
              // if (this.roomInfo.usersCount <= environment.networking.allowed_limit) {
              //   this.cIndex = 0;
              // } else {
              //   let r = this.roomInfo.usersCount / environment.networking.allowed_limit;
              //   if (Number.isInteger(r)) {
              //     this.cIndex = r - 1;
              //   } else {
              //     this.cIndex = Math.floor(r);
              //   }
              // }
              console.log("cIndex", this.roomInfo.usersCount, "vhvhvj", this.cIndex);
              this.currentVideoRoom = this.videoRoomsJson[this.cIndex];
              this.roomName = this.mainRoom.room + " - " + this.currentVideoRoom.id;
            } else {
              this.roomName = this.mainRoom.room;
            }
            if (this.currentVideoRoom && this.currentVideoRoom.room_status == 0 && this.roomInfo.host_manage_subroom == 0) {
              this.createRoom();
              this.isRoomCreating = true;
            } else {
              this.guestConnect();
            }
            this.isDataCalled = true;
          }
          //   this.mainRoom = {
          //     id: this.roomInfo.id,
          //     room: this.roomInfo.name,
          //     participants: []
          //   }
          //   let subRooms = JSON.parse(this.roomInfo.sub_rooms_json);
          //   this.subRoomData = [];
          //   if (subRooms && subRooms.length > 0) {
          //     let i = 1;
          //     subRooms.forEach(element => {
          //       this.subRoomData.push({ id: i++, room: element.subroom_name, participants: [] })
          //     });
          //   } else {
          //     this.subRoomData = [];
          //   }
          //   console.log("MAIN_ROOM: ", this.mainRoom);
          //   console.log("SUB_ROOM: ", this.subRoomData);
          // }
          if (this.roomInfo.room_status == 0 && this.roomInfo.host_manage_subroom == 1) {
            this.toastr.success("Video session is closed");
            this.leaveRoom();
          }
        }
      }
    }).catch(error => {
      console.log("error::", error);
      // this.ngxLoader.stop();
    });
  }

  /// video room /// 

  videoRoom;
  videoUserName;
  host = true;
  myID;
  myRoom = 0;
  roomSelect = 0;
  roomName = "Waiting";
  myStream;
  vrUID;
  gotStreamInterval;
  waitingParticipant = [];
  previewParticipant = [];
  liveParticipant = [];
  startVideoRoom = false;
  copyGuestUrl = false;
  screenShare: any = {
    isSharedScreen: false,
    streamId: ""
  };

  async guestConnect() {
    this.videoUserName = this.userInfo.user_display_name;
    console.log("videoUserName: " + this.videoUserName);
    this.host = false;
    if (this.roomInfo.host_manage_subroom == 0) {
      this.vrUID = this.currentVideoRoom.skreens_unique_id;
      this.videoRoom = this.currentVideoRoom.skreens_access_key;
    } else {
      this.vrUID = this.roomInfo.skreens_unique_id;
      this.videoRoom = this.roomInfo.skreens_access_key;
    }
    this.roomConnect();
  }

  getRoom() {
    $.ajax({
      url: environment.skreens.api_prefix + '/room/' + this.vrUID,
      type: "GET",
      beforeSend: (request) => {
        request.setRequestHeader('x-skr-di-auth-token', this.AuthToken);
      },
      dataType: 'json',
      contentType: "application/json",
      success: (data) => {
        console.log("Video Room access_key " + data.access_key, "data", data);
        this.videoRoom = data.access_key;
        console.log("videoRoom: " + this.videoRoom);
        this.videoUserName = this.uname;
        // document.getElementById("videoRoomDiv").style.display = "block";
        this.startVideoRoom = true;
        this.videoRoomsJson[this.cIndex].skreens_access_key = data.access_key;
        this.videoRoomsJson[this.cIndex].skreens_guest_token = data.guest_token;
        this.videoRoomsJson[this.cIndex].skreens_unique_id = data.unique_id;
        this.videoRoomsJson[this.cIndex].room_status = 1;
        this.updateVideoRooms();
      }
    })
  }

  getRoomInfo() {
    var roomData;
    return new Promise((resolve, reject) => {
      $.ajax({
        url: environment.skreens.api_prefix + '/room-connect/' + this.videoRoom,
        type: "POST",
        dataType: 'json',
        contentType: "application/json",
        success: (data) => {
          console.log("getRoomInfo", JSON.stringify(data));
          roomData = data.room_data;
          resolve(roomData);
        }
      });
    })
  }
  async goConnect() {
    await this.getRoomInfo()
      .then((data: any) => {
        console.log("roomData: " + JSON.stringify(data))
        WTSDK.Session.connect(data.token, this.videoUserName);
      })
      .catch(resp => {
        console.log("resp code ::", resp.code)
        console.error(resp);
      })
  }
  roomConnect() {
    this.isRoomStarted = true;
    this.addListenersEvents();
    console.log("VideoRoom Guest URL: https://media-server.skreens.tv/demos/sampleVideoRoom/guest.html?token=" + this.videoRoom)
    let vw = document.getElementById("videoWrapper");
    this.goConnect();
    this.copyGuestUrl = true;
  }
  // video room end /// 

  // event listeners

  participants: any = [];
  addListenersEvents() {
    WTSDK.SessionListeners.onMosReport(({ participantId, stats }) => {
      if (participantId == this.myID) {
        // console.log("stats: " + JSON.stringify(stats))
        // document.getElementById(`${participantId}-network-video`).innerText = "Network Video: " + stats.video ? "Network Video: " + stats.video : 'N/A';
        // document.getElementById(`${participantId}-network-audio`).innerText = "Network Audio: " + stats.audio ? "Network Audio: " + stats.audio : 'N/A';
        // document.getElementById(`${participantId}-network-rtt`).innerText = "Network RTT: " + stats.RTT ? "Network RTT: " + stats.RTT : 'N/A';
        if (stats.videoStat) {
          //      document.getElementById("MOSFrameRateSpan").innerText = "Measured FrameRate: " + stats.videoStat.frameRate ? "Measured FrameRate: " + stats.videoStat.frameRate: "N/A";
          //      document.getElementById("MOSResolutionSpan").innerText = "Measured Resolution: " + stats.videoStat.frameWidth + " x " + stats.videoStat.frameHeight ? "Measured Resolution: " + stats.videoStat.frameWidth + " x " + stats.videoStat.frameHeight : "N/A" + " x " + "N/A"
          // document.getElementById(`${participantId}-network-frameRate`).innerText = "Network FrameRate: " + (stats.videoStat && stats.videoStat.frameRate) ? "Network FrameRate: " + stats.videoStat.frameRate : "N/A";
        }
        // if (this.myRoom == 2) {  //only update resolution and frameRate from quality when in live room.
        //   switch (stats.video) {
        //     case this.qualityConstants.excellent:
        //       WTSDK.Participant.setMediaQuality({ videoHeight: 720, videoWidth: 1280, frameRate: 30 });
        //       document.getElementById(`${participantId}-connection-container`).style.backgroundColor = '#2dc937'
        //       break;
        //     case this.qualityConstants.good:
        //       WTSDK.Participant.setMediaQuality({ videoHeight: 480, videoWidth: 270, frameRate: 10 });
        //       document.getElementById(`${participantId}-connection-container`).style.backgroundColor = 'yellow'
        //       break;
        //     case this.qualityConstants.bad:
        //       WTSDK.Participant.setMediaQuality({ videoHeight: 144, videoWidth: 81, frameRate: 10 });
        //       document.getElementById(`${participantId}-connection-container`).style.backgroundColor = 'red'
        //       break;
        //     default:
        //   }
        // }
      }
    })

    // WTSDK.ErrorListeners.onSessionError(event => {
    //   // Error handling
    //   if (event.error.code === 206) {
    //     // Handle full room error
    //   }
    // });


    WTSDK.SessionListeners.onConnected(() => {
      //message recieved
      WTSDK.SessionListeners.onMessageReceived(({ message, user }) => {
        console.log("message recieved::", JSON.parse(message))
        this.message = message;
        setTimeout(() => {
          if (this.roomInfo.host_manage_subroom == 0) {
            this.showVideos(this.message);
          } else {
            this.showVideosManual(this.message);
          }
        }, 1000);
      });


      //On participant connect to the Session

      // WTSDK.ParticipantListeners.onParticipantSpeaking(participantId => {
      //   //console.log(participantId + " started talking");
      //   let partContainer = document.getElementById(participantId + "-talking")
      //   partContainer.style.display = "block";
      //   // On participant speaking event
      // });

      // WTSDK.ParticipantListeners.onParticipantStopSpeaking(participantId => {
      //   //console.log(participantId['participantId'] + " stopped talking");
      //   let partContainer = document.getElementById(participantId + "-talking")
      //   partContainer.style.display = "none";
      //   // On participant stop speaking event
      // });

      WTSDK.ParticipantListeners.onParticipantLeft(participantId => {
        console.log("participant: " + participantId['participantId'] + " left");
        let el = document.getElementById(participantId['participantId'] + "-VC");
        if (el)
          el.remove();

        this.mainRoom.participants.forEach((e, w) => {
          if (this.mainRoom.participants[w].id == participantId['participantId']) {
            this.mainRoom.participants.splice(w, 1);
          }
        })
        this.subRoomData.forEach(element => {
          element.participants.forEach((e, w) => {
            if (element.participants[w].id == participantId['participantId']) {
              element.participants.splice(w, 1);
            }
          })
        });
        this.participants.forEach((e, w) => {
          if (this.participants[w].id == participantId['participantId']) {
            this.participants.splice(w, 1);
          }
        });
        if (this.myID == this.hostID && this.roomInfo.host_manage_subroom == 0)
          this.autoCreateSubroom();
      });

      WTSDK.ParticipantListeners.onParticipantMediaStreamChanged(participant => {
        console.log("MediaStateChanged: " + JSON.stringify(participant));
        if (participant.mediaType == 'VIDEO' && participant.mediaState == 'DISABLED') {
          document.getElementById(participant.participantId + '-videoOff').style.display = 'block';
        }
        if (participant.mediaType == 'VIDEO' && participant.mediaState == 'ENABLED') {
          document.getElementById(participant.participantId + '-videoOff').style.display = 'none';
        }
        if (participant.mediaType == 'AUDIO' && participant.mediaState == 'DISABLED') {
          document.getElementById(participant.participantId + '-audioOff').style.display = 'block';
        }
        if (participant.mediaType == 'AUDIO' && participant.mediaState == 'ENABLED') {
          document.getElementById(participant.participantId + '-audioOff').style.display = 'none';
        }
      })

      WTSDK.SessionListeners.onStreamCreated(stream => {
        const { local, participantName, streams, participantId, settings } = stream;
        if (!document.getElementById(participantId + "-VC")) {
          console.log("onStreamCreated stream: " + JSON.stringify(stream));
          let partContainer = document.createElement("div");
          partContainer.id = participantId + "-VC";

          let videoContainer = document.createElement("div");
          videoContainer.className = "videoContainer video-container stream-video";
          let video = document.createElement("video");
          video.id = participantId;
          video.className = local ? "local w-100 video-fit" : "remote w-100 video-fit";
          video.autoplay = true;
          video.muted = local ? true : false;
          video.srcObject = stream.stream;
          let videoOff = document.createElement("img");
          videoOff.className = "video-off";
          videoOff.id = participantId + "-videoOff";
          // videoOff.setAttribute("src", this.assets_url + "stream-icons/video.svg");
          videoOff.setAttribute("src", this.svgService.video);
          videoOff.style.display = settings.mutedVideo ? "block" : "none";
          videoContainer.appendChild(video);
          videoContainer.appendChild(videoOff);

          let audioOff = document.createElement("img");
          audioOff.className = "audio-off";
          audioOff.id = participantId + "-audioOff";
          // audioOff.setAttribute("src", this.assets_url + "stream-icons/mic.svg");
          audioOff.setAttribute("src", this.svgService.mic);
          audioOff.style.display = settings.mutedAudio ? "block" : "none";

          let partExists = false;
          this.participants.forEach((e, i) => {
            if (this.participants[i].id == stream.participantId && this.participants[i].name == stream.participantName) {
              partExists = true;
            }
          });

          if (!partExists) {
            this.participants.push({ id: stream.participantId, name: stream.participantName, local: stream.local, uri: "https://director.skreens.tv/room/#/participant-only?access_key=" + this.videoRoom + "&participant_id=" + stream.participantId });
          }

          if (local) {
            this.myStream = stream.stream;
            this.myID = participantId;
            if (this.isRoomCreating || this.roomInfo.usersCount == 1) {
              this.hostID = participantId;
            }
            if (this.isExpand) {
              partContainer.className = "participantLocal col-md-6 relative vid-block";
            } else {
              partContainer.className = "participantLocal col-md-3 relative vid-block";
            }
            console.log("local");
            let locWrapper = document.createElement("div");
            locWrapper.id = participantId + "-locDiv";
            locWrapper.className = "locDiv"

            partContainer.appendChild(videoContainer);

            let container = document.querySelector("#videoWrapper");
            let partNameMain = document.createElement("div");
            partNameMain.className = "partNameCls";
            let partNameDiv = document.createElement("div");
            partNameDiv.id = participantId + "-partNameDiv"
            let partName = document.createElement("span");
            partName.id = participantId + "-partNameSpan"
            partNameDiv.className = "partNameLocal";
            partName.textContent = participantName;
            partNameDiv.appendChild(audioOff);
            partNameDiv.appendChild(partName);
            partNameMain.appendChild(partNameDiv);
            videoContainer.appendChild(partNameMain);
            container.appendChild(partContainer);

            let meterGraph = document.createElement("div");
            meterGraph.id = "meterGraph";
            let meter = document.createElement("div");
            meter.id = "meter"
            meterGraph.appendChild(meter);
            partContainer.appendChild(meterGraph);

          } else {
            if (this.isExpand) {
              partContainer.className = "participant col-md-6 relative vid-block";
            } else {
              partContainer.className = "participant col-md-3 relative vid-block";
            }
            partContainer.appendChild(videoContainer);
            let container = document.querySelector("#videoWrapper");
            let partNameMain = document.createElement("div");
            partNameMain.className = "partNameCls";
            let partNameDiv = document.createElement("div");
            partNameDiv.id = participantId + "-partNameDiv"
            let partName = document.createElement("span");
            partName.id = participantId + "-partNameSpan"
            partNameDiv.className = "partName";
            partName.textContent = participantName;
            partNameDiv.appendChild(audioOff);
            partNameDiv.appendChild(partName);
            partNameMain.appendChild(partNameDiv);
            partContainer.appendChild(partNameMain);
            container.appendChild(partContainer);

          }
          // this.roomSelected();
          if (this.hostID == this.myID && this.roomInfo.host_manage_subroom == 0) {
            let partObj = { id: stream.participantId, name: stream.participantName, userColor: '', shortName: '', mute: false }
            partObj.userColor = this.getColor(partObj);
            partObj.shortName = this.getName(partObj.name);
            this.mainRoom.participants.push(partObj);
            this.autoCreateSubroom();
          }
        }
      });
    });
  }

  soundStatus = true;
  vidStatus = true;
  soundOff() {
    let muteButton = document.getElementById("audioButton");
    if (this.soundStatus) {
      // muteButton.setAttribute("src",this.assets_url + "stream-icons/mic.svg");
      this.audio_Icon = 'mic';
      WTSDK.Participant.disableAudio();
    } else {
      // muteButton.setAttribute("src", this.assets_url + "stream-icons/mic-hover.svg");
      this.audio_Icon = 'mic-hover';
      WTSDK.Participant.enableAudio();
    }
    this.soundStatus = !this.soundStatus;
  }
  vidOff() {
    let videoButton = document.getElementById("videoButton");
    if (this.vidStatus) {
      // videoButton.setAttribute("src", this.assets_url + "stream-icons/video.svg");
      this.video_Icon = 'video';
      WTSDK.Participant.disableVideo();
    } else {
      // videoButton.setAttribute("src", this.assets_url + "stream-icons/video-hover.svg");
      this.video_Icon = 'video-hover';
      WTSDK.Participant.enableVideo();
    }
    this.vidStatus = !this.vidStatus;
  }
  leaveRoom() {
    console.log()
    this.isDisconnected = true;
    let index = this.getIndex(this.participants, this.myID, "id");
    console.log(index, "disc", this.myID, " parts::", this.participants);
    if (index != -1) {
      this.participants.splice(index, 1);
    }
    console.log("disc parts::", this.participants);

    if (this.participants.length == 0 && this.roomInfo.host_manage_subroom == 0) {
      this.deleteRoom();
    } else {
      this.disconnect();
    }
  }
  disconnect(): any {
    return new Promise((resolve, reject): any => {
      this.isDisconnectRoom = true;
      if (this.hostID == this.myID && this.roomInfo.host_manage_subroom == 0) {
        this.hostID = this.participants[0].id;
        this.subRoomData.forEach(element => {
          element.participants.forEach((e, w) => {
            if (element.participants[w].id == this.myID) {
              element.participants.splice(w, 1);
            }
          })
        });
        this.autoCreateSubroom();
      }
      setTimeout(() => {
        this.endSession();
      }, 500);
      resolve("success");
      // this.router.navigateByUrl(`event/networking-list/${this.route.snapshot.params.ticket_key}`);
      // this._location.back();
    });
  }
  // quest connect
  endSession() {
    let params = {
      id: this.session_id,
      endTime: new Date(),
      network_room_id: this.roomId
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: params
    }
    let url = CONST_AWS_API.END_NETWORK_ROOM_SESSION;
    AWS_API.post(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        if (this.isDisconnectRoom) {
          WTSDK.Session.disconnect();
        }
        $('#videoWrapper').html('');
        this.participants = [];
        this.mainRoom.participants = [];
        this.subRoomData = [];
        const _channelName = this.router.url.split('/')[1];
        const _segment2 = this.router.url.split('/')[2];
        const _groupSlug = _segment2 && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list'].includes(_segment2) ? _segment2 : '';
        const _base = _groupSlug ? `/${_channelName}/${_groupSlug}` : `/${_channelName}`;
        this.router.navigateByUrl(`${_base}/event/networking-list/${this.route.snapshot.params.ticket_key}`);
        // this._location.back();
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }
  goBack() {
    this.leaveRoom();
  }

  ngOnDestroy() {
    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    }
    if (this.networkInterval) {
      clearInterval(this.networkInterval);
    }
    // if (this.showVideoInterval) {
    //   clearInterval(this.showVideoInterval);
    // }
    if (!this.isDisconnected)
      this.leaveRoom();
  }
  expand() {
    this.isExpand = !this.isExpand;
    if (this.isExpand) {
      $('.vid-block').addClass('col-md-6');
      $('.vid-block').removeClass('col-md-3');
    } else {
      $('.vid-block').addClass('col-md-3');
      $('.vid-block').removeClass('col-md-6');
    }
  }
  checkIsElement(id) {
    if (document.getElementById(id)) {
      return true;
    }
    return false;
  }
  sendList() {
    let d = { mainRoom: this.mainRoom, subRoomData: this.subRoomData, hostID: this.hostID }
    console.log("sendMessage: " + JSON.stringify(d));
    WTSDK.Session.sendMessage(JSON.stringify(d));
    this.message = JSON.stringify(d);
    setTimeout(() => {
      if (this.roomInfo.host_manage_subroom == 0) {
        this.showVideos(this.message);
      } else {
        this.showVideosManual(this.message);
      }
    }, 1000);
  }
  showVideos(message) {
    let m = JSON.parse(message);
    console.log("message :::", m);
    this.mainRoom = m.mainRoom;
    this.subRoomData = m.subRoomData;
    if (m.hostID == this.myID) {
      this.hostID = m.hostID;
    }
    let hostIndex = this.mainRoom.participants.findIndex(ele => ele.id == this.myID);
    if (hostIndex != -1) {
      this.subRoomName = "Main Room"//this.mainRoom.room
      this.participants.forEach(e => {
        let hIndex = this.mainRoom.participants.findIndex(ele => ele.id == e.id);
        if (hIndex == -1) {
          let el = <HTMLElement>document.getElementById(e.id + "-VC");
          if (el) {
            el.remove();
          }
        }

      });
    } else {
      this.subRoomData.forEach(element => {
        if (element.participants.findIndex(e => e.id == this.myID) != -1) {
          this.subRoomName = element.room;
          this.participants.forEach(e => {
            let hIndex = element.participants.findIndex(ele => ele.id == e.id);
            if (hIndex == -1) {
              let el = <HTMLElement>document.getElementById(e.id + "-VC");
              if (el) {
                el.remove();
              }
            }
          });
        }
      });
    }
    this.ngxLoader.stop();
  }

  showVideosManual(data) {
    let m = JSON.parse(data);
    console.log("message", m)
    this.mainRoom = m.mainRoom;
    this.subRoomData = m.subRoomData;
    let hostIndex = this.mainRoom.participants.findIndex(ele => ele.id == this.myID);
    if (hostIndex != -1) {
      this.subRoomName = "Main Room"//this.mainRoom.room
      this.participants.forEach(e => {
        let hIndex = this.mainRoom.participants.findIndex(ele => ele.id == e.id);
        if (hIndex != -1) {
          if (this.checkIsElement(e.id))
            (<HTMLVideoElement>document.getElementById(e.id)).play();
          else
            console.error("Not found :: ", e.id)
          if (this.checkIsElement(e.id + "-VC"))
            document.getElementById(e.id + "-VC").style.display = "block";
        } else {
          if (this.checkIsElement(e.id))
            (<HTMLVideoElement>document.getElementById(e.id)).pause();
          else
            console.error("Not found :: ", e.id)
          if (this.checkIsElement(e.id + "-VC"))
            document.getElementById(e.id + "-VC").style.display = "none";
        }
      });
    } else {
      this.subRoomData.forEach(element => {
        if (element.participants.findIndex(e => e.id == this.myID) != -1) {
          this.subRoomName = element.room;
          this.participants.forEach(e => {
            let hIndex = element.participants.findIndex(ele => ele.id == e.id);
            if (hIndex != -1) {
              if (this.checkIsElement(e.id))
                (<HTMLVideoElement>document.getElementById(e.id)).play();
              else
                console.error("Not found :: ", e.id)
              if (this.checkIsElement(e.id + "-VC"))
                document.getElementById(e.id + "-VC").style.display = "block";
            } else {
              if (this.checkIsElement(e.id + "-VC")) {
                let el = document.getElementById(e.id + "-VC");
                if (el)
                  el.remove();
              }
            }
          });
        }
      });
    }
    this.ngxLoader.stop();
  }

  createRoom() {
    let roomName = this.roomInfo.event_id + "_" + this.roomInfo.id + "_" + this.currentVideoRoom.id + "_" + this.roomName + "-Networking";//this.expoInfo.event_id + "_" + this.expoInfo.id + "_" + this.expoRoomInfo.id + "_" + new Date().getTime() + "_Expo";
    let roomData = { name: roomName, ref_name: "", room_type: "sc", session_uid: "", start_immediately: true, stream_uid: "" };
    $.ajax({
      url: environment.skreens.api_prefix + '/room',
      type: "POST",
      beforeSend: (request) => {
        request.setRequestHeader('x-skr-di-auth-token', this.AuthToken);
      },
      data: JSON.stringify(roomData),
      dataType: 'json',
      contentType: "application/json",
      success: (data) => {
        this.vrUID = data.unique_id
        this.getRoom();
      }
    })
  }

  updateVideoRooms() {
    let room_status = 1;
    if (this.videoRoomsJson && this.videoRoomsJson.length > 0 && this.roomInfo.host_manage_subroom == 0) {
      room_status = 0;
      this.videoRoomsJson.forEach(element => {
        if (element.room_status == 1) {
          room_status = 1;
        }
      });
    }
    setTimeout(() => {
      let params = {
        id: Number(this.roomId),
        room_status: room_status,
        video_rooms_json: JSON.stringify(this.videoRoomsJson),
        sessionList: this.sessionList
      }
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`
        },
        response: true,
        body: params
      }
      let url = CONST_AWS_API.UPDATE_NETWORK_VIDEO_ROOMS;
      AWS_API.post(environment.AWS_Cognito.apiName, url, data).then(response => {
        if (response.data.statusCode === '200') {
          console.log(this.videoRoomsJson[this.cIndex].room_status, "videoRoom: " + this.videoRoom);
          if (this.videoRoomsJson[this.cIndex].room_status == 1) {
            this.startVideoRoom = true;
            this.guestConnect();
          } else {
            this.isStarted = false;
            this.startVideoRoom = false;
            this.videoRoom = '';
            this.vrUID = '';
          }
          // this.guestConnect();
          // this.router.navigateByUrl(`event/networking-list/${this.route.snapshot.params.ticket_key}`);
          // this._location.back();
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    }, 200);
  }
  getIndex(arr, value, i) {
    let index = arr.findIndex(x => x[i] === value);
    console.log("index", index)
    return index;
  }
  autoCreateSubroom() {
    this.subRoomData.forEach((element, i) => {
      if (element.participants.length == 0) {
        this.subRoomData.splice(i, 1);
      }
    });
    let c = this.participants.length;
    console.log("count ::", c);
    let tr = Math.ceil(c / this.roomInfo.persons_allowed_subroom);
    let slength = this.subRoomData.length;
    let rr = tr - slength;
    if (rr > 0) {
      // if (c >= this.roomInfo.persons_allowed_subroom) {
      console.log("required rooms ::", rr);
      for (let i = 1; i <= rr; i++) {
        this.subRoomData.push({ id: i + slength, room: this.roomName + " - " + (i + slength), participants: [] });
      }
    }
    this.assignParticipantsToSubroom();
  }
  assignParticipantsToSubroom() {
    this.subRoomData.forEach(ele => {
      if (this.mainRoom.participants.length > 0) {
        this.mainRoom.participants.forEach((element, j) => {
          if (ele.participants.length < this.roomInfo.persons_allowed_subroom) {
            if (this.getIndex(ele.participants, element.id, 'id') == -1) {
              // element.mute = false;
              ele.participants.push(element);
            }
          }
        });
        ele.participants.forEach(e => {
          let index = this.getIndex(this.mainRoom.participants, e.id, "id");
          if (index != -1)
            this.mainRoom.participants.splice(index, 1);
        });
      }
    });
    console.log("MAIN_ROOM: ", this.mainRoom);
    console.log("SUB_ROOM: ", this.subRoomData);
    this.isAutoAssign = true;
    this.sendList();
  }
  loginSubmit() {
    this.ngxLoader.start();
    this.appService.postRequest(API.GET_SKREENS_TOKEN,'').subscribe(
      (response) => {
        this.ngxLoader.stop();
        if (response.status == 0) {
          this.AuthToken = response['session_id'];
          this.orgID = response['org_uid'];
          console.log("orgID: " + this.orgID)
          this.getRoomById();
        }
      },
      (error) => {
        console.log(error);
      }
    )
    // this.ngxLoader.start();
    // let Data = {
    //   username: environment.skreens.username,
    //   password: environment.skreens.password,
    //   dest: environment.skreens.dest
    // };
    // $.ajax({
    //   url: environment.skreens.api_prefix + '/auth/sign-in',
    //   type: "POST",
    //   data: JSON.stringify(Data),
    //   dataType: "json",
    //   contentType: "application/json",
    //   statusCode: {
    //     401: () => {
    //       console.log("statusCode - 403 Not Authorized");
    //       alert("incorrect username/password - please try again");
    //     },
    //   },
    //   success: (data) => {
    //     this.AuthToken = data['session_id'];
    //     console.log("AuthToken: " + this.AuthToken);
    //     this.org_id();
    //     // this.startRoom();
    //     this.getRoomById();
    //   }
    // });
  }
  org_id() {
    $.ajax({
      url: environment.skreens.api_prefix + '/auth/me',
      type: "GET",
      beforeSend: (request) => {
        request.setRequestHeader('x-skr-di-auth-token', this.AuthToken);
      },
      dataType: 'json',
      contentType: "application/json",
      success: (data) => {
        this.orgID = data.org_uid;
        console.log("orgID: " + this.orgID)
        setInterval(() => {
          this.apiKeepAlive();
        }, 15000);
        // document.getElementById("onConnect").style.display = "block";
        // document.getElementById("overlay").style.display = "none";
      }
    })
  }
  apiKeepAlive() {
    $.ajax({
      url: environment.skreens.api_prefix + '/auth/me',
      type: "GET",
      beforeSend: (request) => {
        request.setRequestHeader('x-skr-di-auth-token', this.AuthToken);
      },
      dataType: 'json',
      contentType: "application/json",
      success: (data) => {
        // console.log(data, "data");
      }
    })
  }
  getColor(message) {
    let color = "";
    if (!this.userColor[message.id]) {
      color = COLORLIST[this.countUserColor];
      this.userColor[message.id] = COLORLIST[this.countUserColor];
      if (this.countUserColor > COLORLIST.length) {
        this.countUserColor = 0;
      } else {
        this.countUserColor++;
      }
    } else {
      color = this.userColor[message.id];
    }
    return color;
  }
  getName(name) {
    let returnString = "";
    if (name) {
      let a = name.split(" ");
      if (a.length > 1) {
        returnString = a[0].charAt(0);
        returnString += a[1].charAt(0);
        return returnString;
      } else if (name) {
        returnString = a[0].charAt(0);
        returnString += a[0].charAt(1);
        return returnString;
      } else {
        return returnString;
      }
    }
  }

  deleteRoom() {
    let arr = []
    this.roomInfo.networkUsers.forEach(element => {
      if (element.is_session == 1) {
        arr.push(element.id)
      }
    });
    this.isClosing = 1;
    this.sessionList = arr;
    this.currentVideoRoom.room_status = 0;
    this.videoRoomsJson[this.cIndex] = this.currentVideoRoom;
    this.updateVideoRooms();
    const vrUID = this.vrUID;
    const AuthToken = this.AuthToken;
    // console.log("this.roomDetails", this.roomDetails);
    WTSDK.Session.disconnect();
    this.isStarted = false;
    let roomData = { action: 'stop' };
    $.ajax({
      async: false,
      url: environment.skreens.api_prefix + '/room/' + vrUID + '/action',
      type: "PUT",
      beforeSend: (request) => {
        request.setRequestHeader('x-skr-di-auth-token', AuthToken);
      },
      data: JSON.stringify(roomData),
      dataType: 'json',
      contentType: "application/json",
      success: (data) => {
        $.ajax({
          async: false,
          url: environment.skreens.api_prefix + '/room/' + vrUID,
          type: "DELETE",
          beforeSend: (request) => {
            request.setRequestHeader('x-skr-di-auth-token', AuthToken);
          },
          data: JSON.stringify(roomData),
          dataType: 'json',
          contentType: "application/json",
          success: (data) => {
            $('#videoWrapper').html('');
            this.participants = [];
            this.mainRoom.participants = [];
            this.subRoomData = [];
            const _channelName2 = this.router.url.split('/')[1];
            const _segment2b = this.router.url.split('/')[2];
            const _groupSlug2 = _segment2b && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list'].includes(_segment2b) ? _segment2b : '';
            const _base2 = _groupSlug2 ? `/${_channelName2}/${_groupSlug2}` : `/${_channelName2}`;
            this.router.navigateByUrl(`${_base2}/event/networking-list/${this.route.snapshot.params.ticket_key}`);
          }
        })
      }
    })
  }

  loadAdsScript() {
    document.querySelectorAll('.videoAds').forEach(vid => (<HTMLVideoElement>vid).pause());
    $('.carousel-inner img').attr('alt', '');
    $('.carousel-inner img').attr('title', '');
    var t;
    var start = $('#myCarousel').find('.active').attr('id');
    t = setTimeout("$('#myCarousel').carousel({interval: 1000});", start - 1000);
    $('#myCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(t);
      var duration1 = $(this).find('.active').attr('id');
      console.log(duration1);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#myCarousel').carousel('pause');
      t = setTimeout("$('#myCarousel').carousel();", duration1 - 1000);
    })
    $('.carousel-control-next').on('click', () => {
      clearTimeout(t);
    });
    $('.carousel-control-prev').on('click', () => {
      clearTimeout(t);
    });
    var r;
    var start = $('#RightCarousel').find('.active').attr('id');
    r = setTimeout("$('#RightCarousel').carousel({interval: 1000});", start - 1000);
    $('#RightCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(r);
      var duration2 = $(this).find('.active').attr('id');
      console.log(duration2);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        // vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#RightCarousel').carousel('pause');
      r = setTimeout("$('#RightCarousel').carousel();", duration2 - 1000);
    })
    $('.carousel-control-next').on('click', () => {
      clearTimeout(r);
    });
    $('.carousel-control-prev').on('click', () => {
      clearTimeout(r);
    });
  }

  eventDetails(slugData) {
    if (this.streamAds) {
      this.streamAds = slugData['stream_info']['stream_ads'];
      console.log('All ads from dynamo', this.streamAds);
      this.streamAdsData = [];
      if (this.streamAds && this.streamAds.length > 0) {
        this.streamAds.forEach(element => {
          if (element.ad_size && element.ad_size == "728x90" || element.ad_size == "300x600") {
            this.streamAdsData.push(element);
          }
        });
        console.log('Schedule page ads from dynamo', this.streamAdsData);
        if (this.streamAdsData.length > 0) {
          this.getAds();
        }
      }
    }
  }
  selectedAdData: any;
  async getAds() {
    let allDiv = [];
    let count = 0;

    var temp_site_id = null;
    this.preloadAdsdata = [];
    if (this.streamAdsData && this.streamAdsData.length > 0) {
      this.sponsorData = this.streamAdsData;
      var j = 0;
      var i = 1;

      var adTypeIdarr = [];
      var placements = [];
      this.streamAdsData.forEach(el => {
        temp_site_id = Number(el.site_id)
        j += 1;
        adTypeIdarr.push(el.adTypeId);
        placements.push({
          "divName": "div" + i + j,
          "networkId": Number(environment.kevel.NETWORK_ID),
          "siteId": Number(el.site_id),
          "adTypes": [el.adTypeId],
          "campaignId": Number(el.campaignId),
          "flightId": Number(el.flight_id),
          "adId": Number(el.ad_id)
        });
        allDiv.push("div" + i + j);
        count = count + 1;
        if (this.streamAdsData.length == count) {
          let data = {
            "placements": placements,
            "allDiv": allDiv
          };
          if (temp_site_id) {
            this.eventHomeAdsTop = [];
            this.eventHomeAdsRight = [];
            this.commanSubscribeService.getAdsData(data, (err, result) => {
              this.preloadAdsdata = result.Ads_data;
              console.log("Schedule page Ads :::: ", this.preloadAdsdata);
              if (this.preloadAdsdata.length > 0) {
                this.preloadAdsdata.forEach(element => {
                  this.selectedAdData = element.clickUrl;
                  console.log('eventHomeAdsRight selectedAdData :: ', this.selectedAdData);
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 728 && element.height == 90) {
                    let adType = element.contents[0];
                    let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    this.adVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsTop.push({ 'image': this.adVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 300 && element.height == 600) {
                    let adType = element.contents[0];
                    // let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    let rightsadVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsRight.push({ 'image': rightsadVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commanSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }
                });
                console.log('scheduleAdsTop :: ', this.eventHomeAdsTop);
                console.log('scheduleAdsRight :: ', this.eventHomeAdsRight);
                setTimeout(() => {
                  this.loadAdsScript();
                }, 200);
              }
            });
          }
        }
      });
    }
  }
}
